import { POST } from '@wellsfargo/ecpfs-authority'

export const DECLINE_E_SIGN_CONSENT = 'register/agreement/decline.json'

export function declineEsign(payload) {
	return POST(DECLINE_E_SIGN_CONSENT, payload)
}
